import React from 'react';

import DropdownSearchFetch from '../../../components/Formik/DropdownSearchFetch';

function DropdownCodigoPostal({ formik, values, names, errors }) {
  let { setFieldValue } = formik;
  return (
    <DropdownSearchFetch
      fluid
      selection
      label="Código Postal"
      value={values.CodigoPostal}
      allowAdditions={values.Pais !== 'MEX'}
      name={names.CodigoPostal}
      onChange={(e, { value }) => {
        setFieldValue(names.CodigoPostal, value);
        setFieldValue(names.Colonia, null);
      }}
      valuesChangesToUpdate={[
        values.Pais,
        values.Estado,
        values.Municipios,
        values.Localidad,
        values.CodigoPostal,
      ]}
      placeholder="Código Postal"
      featherService="catalogo-codigo-postal"
      columName="c_CodigoPostal"
      columValue="c_CodigoPostal"
      mapValues={(value) => {
        return {
          key: Math.random(),
          text: `${value['c_CodigoPostal']}`,
          value: value['c_CodigoPostal'],
        };
      }}
      error={
        errors.CodPos && {
          content: errors.CodPos,
        }
      }
      queryWithSearch={(columName, columValue, searchQuery) => {
        let newQuery = {
          $or: [
            {
              [columName]: {
                $like: '%' + searchQuery + '%',
              },
            },
            {
              [columValue]: {
                $like: '%' + searchQuery + '%',
              },
            },
          ],
          c_Estado: values.Estado,
          c_Municipio: values.Municipio,
          c_Localidad: values.Localidad,
          $limit: 30,
        };

        return newQuery;
      }}
      queryInit={(columName, columValue, value) => {
        let newQuery;
        if (value) {
          newQuery = {
            [columValue]: { $like: value },
            c_Estado: values.Estado,
            c_Municipio: values.Municipio,
            c_Localidad: values.Localidad,
            $limit: 1,
          };
        } else {
          newQuery = {
            $limit: 30,
            c_Estado: values.Estado,
            c_Municipio: values.Municipio,
            c_Localidad: values.Localidad,
          };
        }

        return newQuery;
      }}
    />
  );
}

export default DropdownCodigoPostal;
